// export const loadScript = (url: string) => {
//   return new Promise((resolve, reject) => {
//     const component = document.createElement('script');
//     component.src = url;
//     component.onload = resolve;
//     component.onerror = reject;

//     document.body.appendChild(component);
//   });
// };

type TCache = { [key: string]: () => void };

export const makeLoadScript = () => {
  const cache: TCache = {};

  const handleLoad = (url: string, callback: (...args: Array<unknown>) => void) => () => {
    cache[url] = callback;

    callback();
  };

  return (url: string) => {
    if (cache[url]) {
      return cache[url];
    }

    return new Promise((resolve, reject) => {
      const component = document.createElement('script');
      component.src = url;
      component.onload = handleLoad(url, resolve);
      component.onerror = handleLoad(url, reject);

      document.body.appendChild(component);
    });
  };
};
